import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import settingsIcon from '../../assets/settingsIcon.png';
import { GeneralTexts } from '../../language/Texts';
import { IAttribute } from '../../models/IOutputData';
import AccordionComponent from '../accordionComponent/AccordionComponent';
import KeyValue from '../keyValue/KeyValue';
import SectionTitle from '../sectionTitle/SectionTitle';
import { faGears } from '@fortawesome/free-solid-svg-icons';


interface ComponentAtrributesProps {
    attributes: IAttribute[]
}

function ComponentAtrributes({ attributes }: ComponentAtrributesProps) {

    const componentBody = <KeyValue attributes={attributes} />

    const titleComponent =
        <SectionTitle
            icon={<FontAwesomeIcon
                className="section_title_icon"
                icon={faGears} />}
            title={GeneralTexts.componentAttributes} />

    return (
        <>
            {attributes.length > 0 &&
                <AccordionComponent
                    title={titleComponent}
                    body={componentBody}
                />}
        </>
    )
}

export default ComponentAtrributes
